import { NAV_MENU_TYPE } from '../types';

import editIcon from '../assets/navbar-edit.svg';
import communityIcon from '../assets/navbar-community.svg';
import vaultIcon from '../assets/navbar-vault.svg';

export const MENU_LIST_CONFIG = [
    {
        type: NAV_MENU_TYPE.NEW_TASK,
        icon: editIcon,
        link: '/home',
        router: '/home',
        module: NAV_MENU_TYPE.NEW_TASK,
    },
    {
        type: NAV_MENU_TYPE.SEARCH_TASK,
        icon: 'SolidSearchLeft',
        link: '/search-task',
        router: '/search-task',
        module: NAV_MENU_TYPE.SEARCH_TASK,
    },
    {
        type: NAV_MENU_TYPE.CUSTOM_AGENT,
        icon: 'SolidInsightsTechnology',
        link: '/explore',
        router: '/explore',
        module: NAV_MENU_TYPE.CUSTOM_AGENT,
        authKey: 'custom_table_permission',
    },
    {
        type: NAV_MENU_TYPE.AI_STUDIO,
        icon: 'SolidChartTopipc',
        link: '/ai-studio',
        router: '/agents',
        module: NAV_MENU_TYPE.AI_STUDIO,
        authKey: 'ai_agent_studio',
    },
    {
        type: NAV_MENU_TYPE.MONITOR,
        icon: 'SolidAim',
        link: '/monitor/#/my?from=invite-monitor-nav',
        router: '/my',
        module: NAV_MENU_TYPE.MONITOR,
    },
    {
        type: NAV_MENU_TYPE.WORK_PROJECT,
        icon: 'SolidFolderMany',
        link: '/rd/#/graph',
        module: NAV_MENU_TYPE.WORK_PROJECT,
        authKey: 'work_project',
    },
    {
        type: NAV_MENU_TYPE.VAULT,
        icon: vaultIcon,
        link: '/vault',
        router: '/vault',
        module: NAV_MENU_TYPE.VAULT,
        authKey: 'vault_permission',
    },
    {
        type: NAV_MENU_TYPE.COMMUNITY,
        icon: communityIcon,
        link: '/rd-gallery?product=RD',
        module: NAV_MENU_TYPE.COMMUNITY,
    }
];

export const INCOGNITO_MENU_ITEM = {
    type: NAV_MENU_TYPE.INCOGNITO,
    icon: 'SolidSecutiry',
}

export const EVENTS_CONFIG = {
    [NAV_MENU_TYPE.HOME]: 'SS Seek Search',
    [NAV_MENU_TYPE.AI_STUDIO]: 'SS AI Studio',
    [NAV_MENU_TYPE.AI_GENERATE]: 'SS AI Agent',
    [NAV_MENU_TYPE.MONITOR_TOPIC]: 'SS News Letter',
    [NAV_MENU_TYPE.MONITOR_SUBSCRIPTION]: 'SS News Letter',
    [NAV_MENU_TYPE.INCOGNITO]: 'SS Seek Search',
    [NAV_MENU_TYPE.WORK_PROJECT]: 'SS Work Project',
    [NAV_MENU_TYPE.SEEK_SEARCH]: 'SS Seek Search',
    [NAV_MENU_TYPE.TECH_MIND]: 'SS Idea AI',
    [NAV_MENU_TYPE.TECH_FMEA]: 'SS Tech FMEA',
    [NAV_MENU_TYPE.TECH_RESEARCH]: 'SS Project',
    [NAV_MENU_TYPE.IDEA_EXPLORATION]: 'SS Idea AI',
    [NAV_MENU_TYPE.MATERIAL_MIND]: 'SS Material Mind',
    [NAV_MENU_TYPE.PATENT_DISCLOSURE]: 'SS Patent Disclosure',
    [NAV_MENU_TYPE.TRIZ_MIND]: 'SS TRIZ',
    [NAV_MENU_TYPE.RD_TECH_MIND]: 'SS RD Tech Mind',
};

export const SAVED_OPENED_KEY = 'COMMON_NAV_COLLAPSE';

export const ROUTE_NAME_WHITELIST = ['chatDetail'];
